import { JsonDecoder } from 'ts.data.json';

export interface Store {
    city: string;
    countryIso2: string;
    lat: number;
    lng: number;
    phoneNumber: string;
    postcode: string;
    storeNumber: string;
    street: string;
}

export type Stores = Store[];

export function fetchStores(locale: string): Promise<Stores> {
    return fetch('/api/stores', {
        headers: {
            'Accept-Language': locale,
        },
    })
        .then((response) => response.json())
        .then((json) => storeDecoder.decodeToPromise(json))
        .then((response) => response.data);
}

interface StoresDataResponse {
    data: Stores;
}

const storeDecoder = JsonDecoder.object<StoresDataResponse>(
    {
        data: JsonDecoder.array(
            JsonDecoder.object(
                {
                    city: JsonDecoder.string,
                    countryIso2: JsonDecoder.string,
                    lat: JsonDecoder.number,
                    lng: JsonDecoder.number,
                    phoneNumber: JsonDecoder.string,
                    postcode: JsonDecoder.string,
                    storeNumber: JsonDecoder.string,
                    street: JsonDecoder.string,
                },
                'Store'
            ),
            'Stores'
        ),
    },
    'StoreDataResponse'
);
